import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
import Select from "react-select";

// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

import { Code } from '@mui/icons-material';
// import ServiceTab from './General/ServiceTab';
// import EntityTab from './General/EntityTab';
import { adminMainUrl } from '../../../../../../../Config';
import { DesignationApi } from '../../../../../../../Redux/action/MasterAction';
import MainTab from './Tabs/MainTab';
import BranchTab from './Tabs/BranchTab';

const AWBStockAdd = ({ accessedModules, accessedPermission }) => {
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;

    const [reload, setReload] = useState(false);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [DesignationName, setDesignationName] = useState(null)
    const [DesignationId, setDesignationId] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page
    const dispatch = useDispatch();

    const {
        loadingDesignationTypeApi,
        findDesignationTypeData,
        findDesignationTypeDataError,
    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(DesignationApi(adminMainUrl));
    }, [adminMainUrl, reload]);

    const handleSuccess = () => {
        // Toggle reload to trigger useEffect
        setReload(prev => !prev);
    };

    // Initialize Formik
    const statusChange = async (id) => {
        setSpinnerLoader(true)
        try {
            const response = await fetch(`${adminMainUrl}/api/designation/status-change`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                },
                body: JSON.stringify({ id: id.toString() }),
            });

            const data = await response.json();

            if (response.ok) {
                setSpinnerLoader(false)
                handleSuccess(); // Call the success handler
                toast.success(data?.msg);
            } else {
                setSpinnerLoader(false)
                toast.error(data?.msg);
            }
        } catch (error) {
            setSpinnerLoader(false)
            console.error('Network error:', error);
        }
    };

    const customerOptions = [
        { value: 1, label: "Rohit" },
        { value: 2, label: "Ravi" },
        { value: 3, label: "Sakshi" },
        { value: 4, label: "Abhishek" },
        { value: 5, label: "Shweta" },
    ]

    const salesPersonOptions = [
        { value: 1, label: "Rohit" },
        { value: 2, label: "Ravi" },
        { value: 3, label: "Sakshi" },
        { value: 4, label: "Abhishek" },
        { value: 5, label: "Shweta" },
    ]

    const handleChange = (id) => {
        // if (accessedPermission.includes("state_change_master_data")) {
        statusChange(id);
        // }
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = findDesignationTypeData?.data

    const totalPages = Math.ceil(findDesignationTypeData?.data?.length / itemsPerPage);

    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Function for "Next" and "Previous" buttons
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const arr = new Array(5).fill(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }
    // const columns = [
    //     { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    //     { title: "Date", dataIndex: "date", key: "date" },
    //     { title: "Name", dataIndex: "name", key: "name" },
    //     { title: "Email", dataIndex: "email", key: "email" },
    //     { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    //     { title: "Origin", dataIndex: "origin", key: "origin" },
    //     { title: "Destination", dataIndex: "destination", key: "destination" },
    //     { title: "Shipment Type", dataIndex: "shipmentType", key: "shipmentType" },
    //     { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    //     { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    //     { title: "Action", dataIndex: "action", key: "action" },
    // ];
    const [editshow, setEditShow] = useState(false);
    const handleEditClose = () => setEditShow(false);
    const handleEditShow = () => setEditShow(true);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Name", dataIndex: "Name", key: "Name" },
        { title: "Code", dataIndex: "Code", key: "Code" },
        { title: "Prefix", dataIndex: "Prefix", key: "Prefix" },
        { title: "CheckDigit", dataIndex: "CheckDigit", key: "CheckDigit" },
        { title: "Account No", dataIndex: "AccountNo", key: "AccountNo" },
        { title: "Home Page URL", dataIndex: "HomePageURL", key: "HomePageURL" },
        { title: "Tracking URL", dataIndex: "TrackingURL", key: "TrackingURL" },
        { title: "Status", dataIndex: "Status", key: "Status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const dataSource = [{
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "Commission", // Ensure date formatting as neede
        Code: "ChargeCategory",
        Prefix: "Applicable",
        CheckDigit: "Charge",
        AccountNo: "AE",
        HomePageURL: "xyz",
        TrackingURL: "xyz",
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-success   `}>Active</span>

                {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    },
    {
        key: "1", // Add a unique key for each row
        SNo: "1", // Changed to camelCase
        Name: "Commission", // Ensure date formatting as neede
        Code: "ChargeCategory",
        Prefix: "Applicable",
        CheckDigit: "Charge",
        AccountNo: "AE",
        HomePageURL: "xyz",
        TrackingURL: "xyz",
        Status:
            <>
                <span
                    className={`cursor-pointer  badge badge-pill badge-status bg-danger   `}>Inactive</span>

                {/* <div className="form-check form-switch d-flex justify-content-center">
          <div
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title={value.status === true ? "active" : "inactive"}
          >
              <input
                  className="form-check-input"
                  type="checkbox"
                  id={`flexSwitchCheckChecked-${i}`}
                  checked={value.status === true}
                  onChange={() => handleChange(value.id)}
              />
          </div>
      </div> */}
            </>
        ,
        action: (
            <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                    <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-item cursor-pointer" onClick={handleEditShow}>
                        <i className="ti ti-edit text-blue me-2"></i> Edit
                    </div>

                </div>
            </div>
        )
    }];


    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => setAddShow(false);
    const handleAddShow = () => setAddShow(true);


    //select style
    const customControlStyles = base => ({
        height: 20,
        minHeight: 20
    });

    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    {/* <div className="row">
                        <div className="col-md-12">
                           
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Organization List<span className="count-title">23</span>
                                        </h4>
                                    </div>
                                    <div className="col-4 text-end">
                                        <div className="head-icons">
                                            <a
                                                href="javascript:void(0);"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-original-title="Collapse"
                                                id="collapse-header"
                                            >
                                                <i className="ti ti-chevrons-up" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </div> */}
                    <div className="card">

                        <div className="card-body">

                            {/* Filter */}
                            <div className="d-flex align-items-end justify-content-between flex-wrap row-gap-2 mb-3">
                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                    <div className="row">

                                        <div className="col-md-6">
                                            <div className="d-flex justify-content-between">
                                                <div>
                                                    <label htmlFor="" className='form-label mb-0'>
                                                    Received Date	

                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="Date"
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>
                                                <div className=' '>
                                                    <label htmlFor="" className='form-label  mb-0'>
                                                    Expiry Date
                                                    </label>
                                                    <div className="icon-forms mb-3 mb-sm-0">
                                                        <input
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Stock Type
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Airline
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                AWB No
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className='  input_box_section'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                End AWB No
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className=' '>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Issuing Carrier	
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                        className='custom-selector '
                                                        name="role_id"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className='  input_box_section'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Branch
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                    <Select
                                                        className='custom-selector '
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className='  input_box_section'>
                                                <label htmlFor="" className='form-label  mb-0'>
                                                Agent's IATA Code
                                                </label>
                                                <div className="icon-forms mb-3 mb-sm-0">
                                                <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name='search_by'
                                                        />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}
                            {/* Contact List */}

                            <div className="row-gap-2">
                                <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="Service-tab" data-bs-toggle="pill" data-bs-target="#Service" type="button" role="tab" aria-controls="Service" aria-selected="true">Main</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" id="Entity-tab" data-bs-toggle="pill" data-bs-target="#Entity" type="button" role="tab" aria-controls="Entity" aria-selected="false">Branch</button>
                                    </li>

                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="Service" role="tabpanel" aria-labelledby="Service-tab">
                                        <MainTab />
                                    </div>
                                    <div className="tab-pane fade" id="Entity" role="tabpanel" aria-labelledby="Entity-tab">
                                        <BranchTab /> 
                                    </div>
                                </div>
                            </div>

                            {/* <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                                        </>
                            } */}
                            {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
                            <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit">
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit">
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit">
                            Close
                        </button>
                    </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
            <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
            {/* <EditEmployee id="offcanvas_edit" />
            <AddEmployee id="offcanvas_add" /> */}
            {/* <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />

            <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
        </>

    )
}

export default AWBStockAdd